import * as angular from 'angular';

const schoolwork12 = window['schoolwork12'] ;

schoolwork12.app.auth = {
        name: 'schoolwork12.auth',
        controllers: {
            login: 'loginController',
            keycodeLogin: 'keycodeLoginController',
            logout: 'logoutController'
        },
        routes: {
            login: '/login',
            loginError: '/loginError',
            keycodeLogin: '/keycodeLogin',
            logout: '/logout'
        },
        events: {
          userLoggedIn: 'auth:user:loggedIn',
          userLoggedOut: 'auth:user:loggedOut',
          backButtonClick: 'auth:user:backButtonClick',
          userLoginError: 'auth:user:loginError'
        },
        templates: {
            login: 'auth/html/login.html',
            loginError: 'auth/html/loginError.html'
        },
        services: {
            authentication: 'authentication',
            httpRequestInterceptor: 'httpRequestInterceptor'
        },
        endpoints: {
            authenticationEndpoint: schoolwork12.app.endpoint.concat('/user/authenticate'),
            refreshKeycodeEndpoint : schoolwork12.app.endpoint.concat('/user/refreshKeycode'),
            keycodeLoginEndpoint : schoolwork12.app.endpoint.concat('/user/authenticateUsingKeycode'),
            logoutEndpoint : schoolwork12.app.endpoint.concat('/user/logout'),
        }
};

angular.module(schoolwork12.app.auth.name, ['ui.router'])
.config(['$stateProvider', '$urlRouterProvider',
   function($stateProvider, $urlRouterProvider) {
     $urlRouterProvider.otherwise("/login");

     $stateProvider.state('login', {
         url: schoolwork12.app.auth.routes.login,
         templateUrl : schoolwork12.app.auth.templates.login,
         data: {
            displayName: ''
         },
     })

     $stateProvider.state('fulfillment', {
         url: schoolwork12.app.fulfillment.routes.fulfillment,
         templateUrl : schoolwork12.app.fulfillment.templates.configureschool,
         data: {
            displayName: 'Manage Computer Rules'
         },
         reloadOnSearch: false
     })

     $stateProvider.state('studentsearch', {
         url: schoolwork12.app.student.routes.studentSearch,
         templateUrl : schoolwork12.app.student.templates.studentSearch,
         data: {
            displayName: 'Student Search'
         },
         reloadOnSearch: false
     })

    $stateProvider.state('studentsearch.student', {
        url: schoolwork12.app.student.routes.studentDetails,
        templateUrl: schoolwork12.app.student.templates.studentDetails,
        data: {
            displayName: 'Student Details',
        },
    })

    $stateProvider.state('studentsearch.student.gradPlan', {
        url: schoolwork12.app.student.routes.studentGradPlan,
        templateUrl: schoolwork12.app.student.templates.studentGradPlan,
        data: {
            displayName: 'Student Graduation Plan'
         },
        reloadOnSearch: false
     })

     $stateProvider.state('fulfillmentApproval', {
         url: schoolwork12.app.fulfillmentApproval.routes.fulfillmentApproval,
         templateUrl : schoolwork12.app.fulfillmentApproval.templates.fulfillmentApproval,
         data: {
            displayName: 'Computer Fulfillment'
         },
         reloadOnSearch: false
     })

     $stateProvider.state('submissionLogs', {
       url: schoolwork12.app.submission.routes.submissionLogs,
       templateUrl : schoolwork12.app.submission.templates.submissionLogs,
        data: {
            displayName: 'Submission Log'
         },
       reloadOnSearch: false
     })

     $stateProvider.state('k12DataManagement', {
       url: schoolwork12.app.k12DataManagement.routes.k12DataManagement,
       templateUrl : schoolwork12.app.k12DataManagement.templates.k12DataManagement,
        data: {
            displayName: 'K12 Data Management'
         },
         reloadOnSearch: false
      })

       $stateProvider.state('k12DataManagement.addClusterConfig', {
        url: schoolwork12.app.k12DataManagement.routes.addClusterConfig,
        templateUrl : schoolwork12.app.k12DataManagement.templates.addClusterConfig,
        params:{
            clusterConfigObject: null,
            operation: null
        },
        data: {
            displayName: 'Cluster Configuration'
         },
        reloadOnSearch: false
     })

     $stateProvider.state('k12DataManagement.systemConfig', {
      url: schoolwork12.app.k12DataManagement.routes.systemConfiguration,
      templateUrl : schoolwork12.app.k12DataManagement.templates.systemConfiguration,
      data: {
          displayName: 'System Configuration'
       },
      reloadOnSearch: false
    })

         $stateProvider.state('graduationPlan', {
       url: schoolwork12.app.graduationPlan.routes.manageGraduationPlan,
       templateUrl : schoolwork12.app.graduationPlan.templates.manageGraduationPlan,
        data: {
            displayName: 'Manage School Graduation Plans'
         },
       reloadOnSearch: false
     })

     $stateProvider.state('graduationPlan.addSchoolPlan', {
        url: schoolwork12.app.graduationPlan.routes.addSchoolPlan,
        templateUrl : schoolwork12.app.graduationPlan.templates.addSchoolPlan,
        data: {
            displayName: 'Add School Graduation Plan'
         },
        reloadOnSearch: false
     })


     $stateProvider.state('graduationPlan.editSchoolPlan', {
        url: schoolwork12.app.graduationPlan.routes.editSchoolPlan + '/:id/:diploma',
        templateUrl : schoolwork12.app.graduationPlan.templates.editSchoolPlan,
        data: {
            displayName: 'Edit ||diploma'
         },
        reloadOnSearch: false
     })

     $stateProvider.state('schoolData', {
       url: schoolwork12.app.manageSchoolData.routes.manageSchoolData,
       templateUrl : schoolwork12.app.manageSchoolData.templates.manageSchoolData,
        data: {
            displayName: 'School Data Management'
         },
       reloadOnSearch: false
     })

     $stateProvider.state('bulkImport', {
       url: schoolwork12.app.bulkImport.routes.bulkImport,
       templateUrl : schoolwork12.app.bulkImport.templates.bulkImport,
        data: {
            displayName: 'Bulk Data Import'
         },
       reloadOnSearch: false
     })

     $stateProvider.state('schoolData.school', {
       url: schoolwork12.app.manageSchoolData.routes.schoolDataDetails,
       templateUrl : schoolwork12.app.manageSchoolData.templates.schoolDataDetails,
        data: {
            displayName: 'School Data Details'
         }
     })

     $stateProvider.state('logout', {
         url: schoolwork12.app.auth.routes.logout,
         controller : schoolwork12.app.auth.controllers.logout,
         reloadOnSearch: false
     })

     $stateProvider.state('keycodelogin',{
         url:schoolwork12.app.auth.routes.keycodeLogin,
         controller: schoolwork12.app.auth.controllers.keycodeLogin
     })

     $stateProvider.state('loginError', {
         url: schoolwork12.app.auth.routes.loginError,
         templateUrl : schoolwork12.app.auth.templates.loginError
     })

      $stateProvider.state('studentgradplanview',{
        url: schoolwork12.app.studentview.routes.studentViewGradPlan,
        //controller: schoolwork12.app.studentview.controllers.studentGradPlanView,
        templateUrl: schoolwork12.app.studentview.templates.studentViewGradPlan,
        data: {
            displayName: 'Student Graduation Plan'
         },
        reloadOnSearch: false
     })

     $stateProvider.state('mailTemplate', {
       url: schoolwork12.app.mailTemplate.routes.manageMailTemplate,
       templateUrl : schoolwork12.app.mailTemplate.templates.manageMailTemplate,
        data: {
            displayName: 'Manage School Mail Templates'
         },
       reloadOnSearch: false
     })

     $stateProvider.state('mailTemplate.addMailTemplate', {
        url: schoolwork12.app.mailTemplate.routes.addMailTemplate,
        templateUrl : schoolwork12.app.mailTemplate.templates.addMailTemplate,
        data: {
            displayName: 'Create New School Mail Template'
         },
        reloadOnSearch: false
     })

     $stateProvider.state('mailTemplate.editMailTemplate', {
        url: schoolwork12.app.mailTemplate.routes.editMailTemplate + '/:id/:templateName',
        templateUrl : schoolwork12.app.mailTemplate.templates.editMailTemplate,
        params : { templateType: null,
                   body: null,
                   subject: null,
                   templateName: null,
                   schools: null,
                   created: null,
                   modified: null,
                   status: null },
        data: {
            displayName: 'Edit ||templateName'
         },
        reloadOnSearch: false
     })
    //STT-9666:  User manages School Clusters in TV Action: Port existing TV Admin page
     $stateProvider.state('adminTools', {
      url: schoolwork12.app.administrationTools.routes.administrationTools,
      templateUrl : schoolwork12.app.administrationTools.templates.administrationTools,
      data: {
          displayName: 'Administration Tools'
       },
      reloadOnSearch: false
    })
    //STT-9741: User enters the 2 persons they want to fix and views errors
    $stateProvider.state('adminTools.fixAdults', {
      url: schoolwork12.app.administrationTools.routes.fixAdults,
      templateUrl : schoolwork12.app.administrationTools.templates.fixAdults,
      data: {
          displayName: 'Administration Tools > Fix Adults'
       },
      reloadOnSearch: false
    })
    //STT-9743: Port the Reactivate Adult functionality from SAMS UI to TV Action
    $stateProvider.state('adminTools.reactivateAdults', {
      url: schoolwork12.app.administrationTools.routes.reactivateAdults,
      templateUrl : schoolwork12.app.administrationTools.templates.reactivateAdults,
      data: {
          displayName: 'Administration Tools > Reactivate Adults'
       },
      reloadOnSearch: false
    })

   $stateProvider.state('courseManagement', {
       url: schoolwork12.app.manageCourseManagement.routes.courseManagement.route,
       templateUrl: schoolwork12.app.manageCourseManagement.routes.courseManagement.templateUrl,
       data: {
           displayName: schoolwork12.app.manageCourseManagement.routes.courseManagement.displayName
       },
       reloadOnSearch: false
   });

   $stateProvider.state('courseManagement.addCourse', {
       url: schoolwork12.app.manageCourseManagement.routes.addCourse.route,
       template : schoolwork12.app.manageCourseManagement.routes.addCourse.template,
       data: {
           displayName: schoolwork12.app.manageCourseManagement.routes.addCourse.displayName
        },
       reloadOnSearch: false
    })
    $stateProvider.state('courseManagement.editCourse', {
       url: schoolwork12.app.manageCourseManagement.routes.editCourse.route,
       template : schoolwork12.app.manageCourseManagement.routes.editCourse.template,
       data: {
           displayName: schoolwork12.app.manageCourseManagement.routes.editCourse.displayName
        },
       reloadOnSearch: false
    })

   $stateProvider.state('pathwayRequirements', {
        url: schoolwork12.app.creManagement.routes.base.route,
        templateUrl: schoolwork12.app.creManagement.routes.base.template,
         data: {
             displayName: schoolwork12.app.creManagement.name
          },
        reloadOnSearch: false
  });

   $stateProvider.state('pathwayRequirements.schoolDetail', {
        url: schoolwork12.app.creManagement.routes.details.route,
        template: schoolwork12.app.creManagement.routes.details.template,
        data: {
           displayName: schoolwork12.app.creManagement.routes.details.title
        },
        reloadOnSearch: false
   });

   $stateProvider.state('studentsearch.student.cre', {
       url: schoolwork12.app.student.routes.cre,
       templateUrl: schoolwork12.app.student.templates.studentCreTracking,
       data: {
           displayName: 'Student Cre Tracking'
       }
   })

   }]);
